import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import MetaTable from 'Components/UI/Meta/MetaTable';
import PropTypes from 'prop-types';
import {
  refreshDetails,
  setRefreshLink,
} from 'Components/AdvisorApp/Viewport/ClientExperienceSaves/ClientExperienceSavesContext';
import { addQuery } from 'Helpers/Query';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';


const styles = () => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    wordWrap: 'breakWord',
    hyphens: 'auto',
  },
});

function EscalatedClients({
  classes, collection, dispatch, ...rest
}) {
  const {
    logEvent,
  } = useEventTrackingLogEvent({
    nodeName: 'Client Experience Saves',
  });

  const onSelectRow = (resource) => {
    const resourceLink = resource.link('self').url();
    setRefreshLink(resourceLink, dispatch);
    addQuery({ selected: resourceLink });
    refreshDetails(resourceLink, dispatch);
    logEvent('Clicked Row In Table');
  };

  const setSelected = (resource) => {
    const url = new URL(window.location.href);
    const selectedLink = url.searchParams?.get('selected');
    return resource.link('self').url() === selectedLink;
  };

  return (
    <div className={classNames(classes.root)} {...rest}>
      {collection && <MetaTable
        classes={classes}
        collection={collection}
        tableMetaOverrideSetName="ClientExperienceSavesEscalatedHouseholdsOverride"
        hasSortableColumns
        features={{
          onClick: onSelectRow,
          isSelected: setSelected,
        }}
      />}
    </div>
  );
}

EscalatedClients.propTypes = {
  classes: PropTypes.object.isRequired,
  collection: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  dispatch: PropTypes.object.isRequired,
};

export default withStyles(styles)(EscalatedClients);
